import styled from "@emotion/styled";

export const ContactInfoStyles = styled("div")`
  .customer-info-panel-data {
    position: relative;
    max-width: 276px;
    padding: 14px 23px 24px 24px;

    &__member-icon {
      width: 66px;
      height: 26px;

      position: absolute;
      top: -23px;
      right: -38px;
    }
    &__loading-benefits {
      width: 18px !important;
      height: 18px !important;

      position: absolute;
      top: -8px;
      right: 10px;
    }

    &__silver-icon {
      display: inline-block;
    }

    &__user-name {
    }

    &__user-since {
      opacity: 0.5;
    }

    &__link-to-crm {
      font-size: 15px;
      font-weight: 500;
      line-height: 1.53;
      letter-spacing: 0.2px;
      text-decoration: underline;
      cursor: pointer;
      color: #3333cc;
    }

    &__phone-link {
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }

    &__separator {
      width: 100%;
      height: 1px;
      margin: 16px 0 0 0;
      opacity: 0.1;
      background-color: rgb(41, 51, 89);
    }

    &__label {
      opacity: 0.5;
      margin: 14px 0 2px 0;
    }

    &__prop {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    &__more {
      margin-top: 12px;
    }

    &__btn-edit {
      background-color: #f4f4f4;
      font-weight: 600;
      color: #474747;
      margin-top: 23px;
      border-radius: 6px;
      width: 102px;
      height: 44px;

      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        background-color: #ebebeb;
      }

      &-icon {
        margin-top: 8px;
      }
    }
  }
`;
